import { render, staticRenderFns } from "./LeaveAdminContainer.vue?vue&type=template&id=b668adc2"
import script from "./LeaveAdminContainer.ts?vue&type=script&lang=ts&external"
export * from "./LeaveAdminContainer.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports